/* GENERATED from storefront-nav.src.js by build/gen_js.py - do not edit.
   The commented source is storefront-nav.src.js. */
(function () {
'use strict';
var header = document.querySelector('.header--studio');
if (!header) return;
var desktop = window.matchMedia('(min-width: 1280px)');
var toggle = header.querySelector('[data-header-rail-toggle]');
var rail = header.querySelector('.header__rail');
var compact = false, expanded = false, queued = false, h39ook86e4bb = 0;
function render() {
var eligible = desktop.matches && header.classList.contains('header--sticky') && !!rail;
var next = eligible && (compact ? window.scrollY > 120 : window.scrollY > 240);
if (next && rail.contains(document.activeElement) && !compact) return;
compact = next;
if (!compact) expanded = false;
header.classList.toggle('header--compact', compact);
header.classList.toggle('header--rail-open', compact && expanded);
if (toggle) {
toggle.hidden = !compact;
toggle.setAttribute('aria-expanded', String(!compact || expanded));
}
}
function schedule() {
if (queued) return;
queued = true;
window.requestAnimationFrame(function () { queued = false; render(); });
}
if (toggle && rail) {
toggle.addEventListener('click', function () { expanded = !expanded; render(); });
header.addEventListener('keydown', function (event) {
if (event.key === 'Escape' && compact && expanded) {
expanded = false; render(); toggle.focus();
}
});
header.addEventListener('focusout', schedule);
window.addEventListener('scroll', schedule, { passive: true });
window.addEventListener('resize', schedule, { passive: true });
render();
}
function sortFocus() {
var sort = document.querySelector('[data-sortui]');
if (!sort) return;
var menu = sort.querySelector('[data-sortui-menu]');
var trigger = sort.querySelector('[data-sortui-btn]');
if (!menu || !trigger) return;
var wasModal = false;
function modal() { return sort.classList.contains('is-open') && window.matchMedia('(max-width:900px)').matches; }
function role() {
var open = modal();
menu.setAttribute('role', open ? 'dialog' : 'group');
if (open) menu.setAttribute('aria-modal', 'true');
else menu.removeAttribute('aria-modal');
if (open && !wasModal) {
var selected = menu.querySelector('[aria-pressed="true"]') || menu.querySelector('button');
if (selected) selected.focus({preventScroll:true});
}
wasModal = open;
}
new MutationObserver(role).observe(sort, {attributes:true, attributeFilter:['class']});
window.addEventListener('resize', role, {passive:true});
document.addEventListener('keydown', function (event) {
if (event.key !== 'Tab' || !modal()) return;
var buttons = Array.prototype.filter.call(menu.querySelectorAll('button:not([disabled])'), function (node) { return node.getClientRects().length > 0; });
var first = buttons[0], last = buttons[buttons.length - 1];
if (first && (!menu.contains(document.activeElement) || (event.shiftKey ? document.activeElement === first : document.activeElement === last))) {
event.preventDefault();
(event.shiftKey ? last : first).focus();
}
});
role();
}
if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', sortFocus, {once:true});
else sortFocus();
var drawer = document.querySelector('#MobileDrawer');
if (!drawer) return;
drawer.addEventListener('keydown', function (event) {
if (event.key !== 'Tab' || drawer.hidden) return;
var items = Array.prototype.filter.call(drawer.querySelectorAll('a[href], button, summary, input, select, textarea, [tabindex="0"]'), function (node) {
return !node.disabled && node.getClientRects().length > 0;
});
if (!items.length) return;
var first = items[0], last = items[items.length - 1];
if (event.shiftKey && document.activeElement === first) { event.preventDefault(); last.focus(); }
else if (!event.shiftKey && document.activeElement === last) { event.preventDefault(); first.focus(); }
});
window.addEventListener('resize', function () {
if (!desktop.matches || drawer.hidden) return;
var close = drawer.querySelector('[data-drawer-close]');
if (close) close.click();
var logo = header.querySelector('.header__logo');
if (logo) logo.focus();
}, { passive: true });
}());
